import { useTranslate } from '@i18n';
import { Button, colors } from '@ui';
import * as css from './TagSelection.css';

type TagControlsProps = {
    onAddTag: () => void;
    onToggleEditable: () => void;
    isEditable: boolean;
};

export const TagControls = ({ onAddTag, onToggleEditable, isEditable }: TagControlsProps) => {
    const t = useTranslate();
    return (
        <div className={css.buttons}>
            <Button size="medium" variant="primary" icon="plus" onClick={onAddTag}>
                {t('generic_ui.add_tag')}
            </Button>
            <Button
                size="medium"
                variant={isEditable ? 'tertiary' : 'secondary'}
                icon="pencil"
                iconColor={isEditable ? colors.blue[500] : colors.current}
                onClick={onToggleEditable}
            >
                {t('generic_ui.edit_tags')}
            </Button>
        </div>
    );
};
